import Vue from 'vue'
import 'vue-material-design-icons/styles.css'
import '@/assets/material-icons.css'
import accountGroup from 'vue-material-design-icons/AccountGroup.vue'
import MenuIcon from 'vue-material-design-icons/Menu.vue'

export default function materialIcons() {
  Vue.component('AccountGroup222', accountGroup)
  Vue.component('MenuIcon', MenuIcon)
}
